// extracted by mini-css-extract-plugin
module.exports =  {"warnLabel":"outdated_warning-module_warnLabel_c0d38","warnBox":"outdated_warning-module_warnBox_fd4da"};